import PigsUnderTreatmentLine from './PigsUnderTreatmentLine';

export default PigsUnderTreatmentLine;
